<template>
  <div class="footer-box no-select">
    <van-tabbar v-model="active" @change="changeLike">
      <van-tabbar-item>
        <span>数据总览</span>
        <template #icon="props">
          <img :src="props.active ? icon.iconHomeActive : icon.iconHome"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>数据查询</span>
        <template #icon="props">
          <img :src="props.active ? icon.iconQueryActive : icon.iconQuery"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>研发动态</span>
        <template #icon="props">
          <img :src="props.active ? icon.iconRdStatusActive : icon.iconRdStatus"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>个人中心</span>
        <template #icon="props">
          <img :src="props.active ? icon.iconUserCenterActive : icon.iconUserCenter"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import iconHome from './images/icon-home.png'
  import iconHomeActive from './images/icon-home-active.png'
  import iconQuery from './images/icon-query.png'
  import iconQueryActive from './images/icon-query-active.png'
  import iconRdStatus from './images/icon-rd-status.png'
  import iconRdStatusActive from './images/icon-rd-status-active.png'
  import iconUserCenter from './images/icon-user-center.png'
  import iconUserCenterActive from './images/icon-user-center-active.png'
  import $ from '../../../static/js/jquery-1.11.1.min'

  export default {
    name: "index",
    data() {
      return {
        active: -1,
        icon: {
          iconHome,
          iconHomeActive,
          iconQuery,
          iconQueryActive,
          iconRdStatus,
          iconRdStatusActive,
          iconUserCenter,
          iconUserCenterActive
        },
      };
    },
    created() {
      if (serviceUtil.isIOS()) {
        if(serviceUtil.isIphoneX()){
          sessionStorage.setItem("isipx","1");
        }else{
          //不是iphoneX
          sessionStorage.setItem("isipx","0");
        }
      }

      // const toName = this.$route.name;
      // this.setActive(toName);
    },
    mounted() {
      if (serviceUtil.isIOS() && serviceUtil.isIphoneX()) {
        let footer = $('.footer-box').find(".van-tabbar--fixed")
        footer.addClass('height-more')
      }
    },
    methods: {
      changeActive({name}) {
        this.setActive(name);
      },
      setActive(name) {
        if (name == 'home' || name == null) {
          this.active = 0
        }
        if (name == 'searchQuery') {
          this.active = 1
        }
        if (name == 'rdStatus') {
          this.active = 2
        }
      },
      changeLike() {
        let tabName = ''
        if (this.active === 0) {
          tabName = '数据总览'
          this.$router.push({
            name: 'home',
            params: {}
          })
        }
        if (this.active === 1) {
          tabName = '数据查询'
          this.$router.push({
            name: 'searchQuery',
            params: {}
          })
        }
        if (this.active === 2) {
          tabName = '研发动态'
          this.$router.push({
            name: 'rdStatus',
            params: {}
          })
        }
        if (this.active === 3) {
          tabName = '个人中心'
          let token = localStore.getItem('pmcucookieH5')
          if (token) {
            window.location.href = globalConfig.serviceUser + '/index?type=3&library=chemistry' //个人中心
          } else {
            window.location.href = globalConfig.serviceUser + "/login?type=3&library=chemistry" //登录页面
          }
        }

        //神策埋点
        this.TracePoint.clickMenu({
          menu_name: tabName,
          is_success: true
        })
      }
    },
    watch: {
      $route: 'changeActive'
    }
  }
</script>

<style scoped>
  .van-tabbar {
    z-index: 30;
    max-width: 1024px;
    height: .96rem;
    margin:0 auto;
  }

  .height-more {
    height: 1.3rem;
  }

  .van-tabbar--fixed {
    left: auto;
  }

  .van-tabbar-item {
    font-size: .2rem;
    font-weight: 400;
    color: #999999;
    line-height: .28rem;
  }

  .van-tabbar-item--active {
    color: #3991F1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue